import { createAuthClient } from 'better-auth/react';

// Better Auth expects the server origin as baseURL (it appends /api/auth internally)
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
const SERVER_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');

export const authClient = createAuthClient({
  baseURL: SERVER_ORIGIN,
  fetchOptions: {
    credentials: 'include', // Required for cross-subdomain cookies
  },
});

// Export type inference for TypeScript
export type Session = typeof authClient.$Infer.Session;
